
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import OrderDescPopup from '@xt/www/components/orderDesc/index.vue'
import Product from '@xt/client/entities/basics/product'

import {
  EnumOrderState,
  EnumProductType,
  EnumProductTypeNameSimple,
  EnumOrderStatusStyle,
  EnumInvoiceState,
  EnumGroupStatus
} from '@xt/client/enums'
import type { OrderItem as OrderItemType } from '@xt/client/entities/my-v2/types.d'

type PopInfo = {
  title: string
  productInfo: Product
  showRefundTime: boolean
  refundStatus: boolean
  refundEndDate: string
  orderStatus: EnumOrderState
  orderStatusStyle: string
  virtualCurrency?: number
  getCoinPayPrice: number
  payAmounts: number
  showInvoiceIng: boolean
  showInvoiceSuccess: boolean
  orderNum: string
}

@Observer
@Component({
  components: { OrderDescPopup }
})
export default class OrderDetailPop extends Vue {
  info: null | PopInfo = null
  visible = false

  showPop(item: OrderItemType) {
    this.info = {
      title: this.mapInfoTitle(item),
      // FIXME!
      productInfo: new Product({ ...item.raw, originalPrice: item.raw.orderAmount } as any),
      showRefundTime: this.getShowRefundTime(item),
      refundStatus: item.isRefundEnd,
      refundEndDate: item.refundEndTime,
      orderStatus: item.orderStatus,
      orderStatusStyle: this.mapInfoStatusStyle(item),
      virtualCurrency: item.raw.virtualCurrency,
      getCoinPayPrice: this.getCoinPayPrice(item),
      payAmounts: item.raw.payAmount,
      showInvoiceIng: this.getShowInvoiceIng(item),
      showInvoiceSuccess: this.getShowInvoiceSuccess(item),
      orderNum: item.orderNo
    }
    this.visible = true
  }

  mapInfoTitle(item: OrderItemType) {
    switch (item.raw.productType) {
      case EnumProductType.single:
      case EnumProductType.fullstage:
        return EnumProductTypeNameSimple.Live
      case EnumProductType.dayCourse:
        return EnumProductTypeNameSimple.DayCourse
      case EnumProductType.selfStudy:
        return EnumProductTypeNameSimple.SelfStudy
      case EnumProductType.onlineExhibition:
      case EnumProductType.offlineExhibition:
        return EnumProductTypeNameSimple.Exhibition
      default:
        return EnumProductTypeNameSimple.Live
    }
  }

  mapInfoStatusStyle(item: OrderItemType) {
    switch (item.raw.orderStatus) {
      case 0:
        return EnumOrderStatusStyle.NotPay
      case 1:
        return EnumOrderStatusStyle.HasPay
      case 2:
        return EnumOrderStatusStyle.Refund
      case 3:
        return EnumOrderStatusStyle.HasRefund
      case 4:
        return EnumOrderStatusStyle.Cancelled
      case 5:
        return EnumOrderStatusStyle.ToBeConfirmed
      default:
        return EnumOrderStatusStyle.Cancelled
    }
  }

  getCoinPayPrice(item: OrderItemType) {
    const { virtualCurrency, orderAmount } = item.raw

    if (virtualCurrency / 100 > orderAmount / 100) {
      return orderAmount / 100
    } else {
      return virtualCurrency / 100
    }
  }

  getShowInvoiceIng(item: OrderItemType) {
    return (
      item.orderStatus === EnumOrderState.HasPay &&
      item.invoiceState === EnumInvoiceState.WaitInvoice &&
      (!item.gift || item.gift.isGiver) &&
      !(item.raw.payAmount <= 0)
    )
  }

  getShowInvoiceSuccess(item: OrderItemType) {
    return (
      item.orderStatus === EnumOrderState.HasPay &&
      item.invoiceState === EnumInvoiceState.HasInvoice &&
      (!item.gift || item.gift.isGiver) &&
      !(item.raw.payAmount <= 0)
    )
  }

  getShowRefundTime(item: OrderItemType) {
    /** 是否是随报随学 */
    return (
      item.raw.signUpEndTime !== 2147000000000 &&
      ![EnumOrderState.NotPay, EnumOrderState.Cancelled, EnumOrderState.HasRefund].includes(item.orderStatus) &&
      (!item.gift || !item.gift.isGiver) &&
      (item.raw.activityType === 0 || item.raw.status !== EnumGroupStatus.Fail)
    )
  }

  closePop() {
    this.visible = false

    this.$nextTick(() => {
      this.info = null
    })
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {
    if (this.info) {
      this.info = null
    }
  }
}
